module.exports = __webpack_public_path__ + "static/media/ibd_back1.87f192ab.png";